import { default as EMBADocumentation } from "./Documentation/Form"
import { CssBaseline } from "@mui/material"
import { ThemeProvider } from "@mui/material/styles"
import { FormContextProvider } from "hooks/useForm"
import Forms from "../Forms"
import theme from "./Theme/index"

const DocumentationEMBA = () => {
  return (
    <FormContextProvider>
      <ThemeProvider theme={theme}>
        <Forms>
          <CssBaseline />
          <EMBADocumentation />
        </Forms>
      </ThemeProvider>
    </FormContextProvider>
  )
}

export { DocumentationEMBA }
